<!-- <div
  [tuxTooltip]="navItem.tooltip"
  tuxTooltipLocation="right-center"
  [tuxTooltipFast]="true"
  [attr.gainsight-id]="navItem.gainsightId"
> -->
<div
  [tuxTooltip]="navItem.tooltip"
  tuxTooltipLocation="right-center"
  [tuxTooltipFast]="true"
>
  <ng-container *ngIf="navItem | isNavLink">
    <a
      *ngIf="navItem?.path?.startsWith('http'); else navRouterLink"
      [href]="navItem.path"
      [target]="navItem.newWindowOpen ? '_blank' : '_self'"
      class="nav-item"
    >
      <ng-container *ngTemplateOutlet="navItemContent"></ng-container>
    </a>
    <ng-template #navRouterLink>
      <a
        [routerLink]="[navItem.path]"
        class="nav-item"
        routerLinkActive="nav-item--active"
        [routerLinkActiveOptions]="{ exact: true }"
        [target]="navItem.newWindowOpen ? '_blank' : '_self'"
      >
        <ng-container *ngTemplateOutlet="navItemContent"></ng-container>
      </a>
    </ng-template>
  </ng-container>
  <button
    *ngIf="navItem | isNavMenu"
    class="nav-item"
    [ngClass]="{ 'nav-item--active': active }"
  >
    <ng-container *ngTemplateOutlet="navItemContent"></ng-container>
  </button>
</div>

<ng-template #navItemContent>
  <img class="icon-image-url" [src]="navItem.iconUrl" *ngIf="navItem.iconUrl" />
  <div class="nav-item__icon" *ngIf="!navItem.iconUrl">
    <fa-icon [icon]="navItem.icon"></fa-icon>
  </div>
  <div *ngIf="navItem | isNavMenu" class="nav-item__caret">
    <fa-icon [icon]="faCaretRight"></fa-icon>
  </div>
</ng-template>
